import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { environment } from '../environments';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  apiUrl: string = environment.apiUrl + 'vendor';

  constructor(private http: HttpClient) { }

  getVendorByCompanyId(vendorName, agentId) {
    let url = `${this.apiUrl}/${vendorName}`;
    if (agentId) url += `?agentId=${agentId}`;
    return this.http.get(url)
  }
}
